<template>
  <div
    class="kk-option-item-description"
    :class="{
      'kk-option-item-description--disabled': isDisabled,
    }"
  >
    {{ description }}
  </div>
</template>

<script>
export default {
  name: 'KkOptionItemDescription',
  props: {
    description: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
